module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-holidays-c428e0058267aefc254b564ddc9fd6a8.jpg";